// extracted by mini-css-extract-plugin
export default {"filterText":"Blog_filterText__VgOtt"};